import Vue from 'vue';
import store from '@/store';
import Main from './main.vue';

const LoginConstructor = Vue.extend(Main);

function Login(opts = {}) {
  return new Promise((resolve, reject) => {
    const instance = new LoginConstructor({
      data: opts,
      store,
    });
    instance.$mount();
    document.body.appendChild(instance.$el);
    instance.show(resolve, reject);
  }).catch((error) => error);
}

export default Login;
